import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { firebaseConfig } from "./firebaseConfig"; // Import the configuration

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export services
export const auth = getAuth(app);
export const db = getFirestore(app);
// Ensure we target the correct storage bucket even if env var is mis-set
const storageBucketUrl = (import.meta as any)?.env
	?.VITE_FIREBASE_STORAGE_BUCKET_URL as string | undefined;
const resolvedBucket =
	storageBucketUrl && storageBucketUrl.startsWith("gs://")
		? storageBucketUrl
		: `gs://${
				(import.meta as any)?.env?.VITE_FIREBASE_STORAGE_BUCKET ||
				firebaseConfig.projectId + ".firebasestorage.app"
		  }`;

export const storage = getStorage(app, resolvedBucket);
